import { fromJS } from 'immutable';

import { actions } from 'react/api/actions/localzIntegrationLogs';

const initialState = fromJS({
  data: [],
  isLoading: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.updateLogs: {
      const { data, shouldClearBeforeUpdateLogs } = action.payload;

      const updateLogs = (actualLogs) => actualLogs && !shouldClearBeforeUpdateLogs ?
        actualLogs.concat(data) : fromJS(data);

      return state.update('data', updateLogs);
    }
    case actions.setIsLoadingLogs: {
      const { isLoading } = action.payload;

      return state.set('isLoading', isLoading);
    }
    case actions.clearLogs:
      return initialState;
    default:
      return state;
  }
};
